import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import { useHistory, useParams } from "react-router-dom";
import CircleGreen from "../../assets/images/circleGreen.gif";
import CircleRed from "../../assets/images/circleRed.gif";
import IconParked from "../../assets/images/icon_parked.png";
import RecentEventsIcon from "../../assets/images/recentEvents.svg";
import ServiceHoursIcon from "../../assets/images/serviceHours.svg";
import { useStyles } from "../../assets/jss/DriverLocator";
import CustomBox from "../../components/CustomComponents/CustomBox/CustomBox";
import CustomCard from "../../components/CustomComponents/CustomCard/CustomCard";
import CustomCheckbox from "../../components/CustomComponents/CustomCheckbox/CustomCheckbox";
import CustomDivider from "../../components/CustomComponents/CustomDivider/CustomDivider";
import CustomFormControlLabel from "../../components/CustomComponents/CustomFormControlLabel/CustomFormControlLabel";
import CustomGrid from "../../components/CustomComponents/CustomGrid/CustomGrid";
import CustomLink from "../../components/CustomComponents/CustomLink/CustomLink";
import DriverLocatorSidebar from "../../components/DriverLocator/DriverLocatorSidebar";
import ErrorAlert from "../../components/ErrorAlert/ErrorAlert";
import { DriverState, SortListBy, SortOrder, DriverLocatorScreenRefreshTime, SortListOrder } from "../../config/app-globals.enum";
import { getDriverList } from "../../services/DriverList";
import L from "leaflet";
import 'leaflet.markercluster';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DateTime from "../../components/DateTime/DateTime";
import Draggable, { DraggableCore } from 'react-draggable';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { Button, Card, Box } from "@material-ui/core";
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import RefreshIcon from '@material-ui/icons/Refresh';
import { getMapUrl } from "../../services/LocalStorageService";
import { getRefreshTime } from "../../services/LocalStorageService";
import clsx from "clsx";

function Counter(props) {
    const { t } = useTranslation();
    const classes = useStyles();
    /**Code for refresh data after specific time interval */
    const nSecondInMiliseconds = 1000;
    const convertSecondsToMiliseconds = (seconds) => seconds * nSecondInMiliseconds;
    const [defaultTimerCount] = useState(getRefreshTime);
    let [timerCount, setTimerCount] = useState(convertSecondsToMiliseconds(defaultTimerCount));
    let [timerString, setTimerString] = useState("");
    let [isResetCounter, setIsResetCounter] = useState(true);
    let [isAutoReset, setIsAutoReset] = useState(false);
    const counterBtn = useRef<any>();

    useEffect(() => {
        if (props.startTimer) {
            const interval = setInterval(() => {
                if (timerCount === 0) {
                    setTimerString("");
                    props.setStartTimer(false);
                    clearInterval(interval);
                    props.setIsRefresh(!props.isRefresh);
                    setTimerCount(convertSecondsToMiliseconds(defaultTimerCount));
                    setIsAutoReset(true);
                } else {
                    setTimerCount((timerCount -= nSecondInMiliseconds));
                    convertMilisecondsToMins()
                }
            }, nSecondInMiliseconds);
            return () => clearInterval(interval);
        }
        // else {
        //     const interval = setInterval(() => {
        //         if (timerCount === 0 && interval) {
        //             clearInterval(interval);
        //             props.setIsRefresh(!props.isRefresh);
        //             setTimerCount(convertSecondsToMiliseconds(defaultTimerCount));
        //             setIsAutoReset(false);
        //         }
        //         setTimerCount((timerCount -= nSecondInMiliseconds));
        //         convertMilisecondsToMins()
        //     }, nSecondInMiliseconds);
        //     return () => clearInterval(interval);
        // }


    }, [props.startTimer]);

    function refreshData() {
        props.setIsRefresh(!props.isRefresh);
        setTimerString("");
        props.setStartTimer(false);
        setIsResetCounter(!isResetCounter);
        setTimerCount(convertSecondsToMiliseconds(defaultTimerCount));
    }

    function convertMilisecondsToMins() {
        let duration = '';
        let timeInsec = timerCount / 1000;
        if (timeInsec && timeInsec > 0 && Number((timeInsec / (60 * 60)).toFixed(2)) >= 1) {
            duration = Math.trunc(timeInsec / (60 * 60)) + " " + t('HOURS');
            duration += " " + timeInsec % (60 * 60) + " " + t('MINUTES');
        }
        else if (timeInsec && timeInsec > 0 && Number((timeInsec / (60)).toFixed(2)) > 1 && Number((timeInsec / (60)).toFixed(2)) < 60) {
            duration = Math.trunc(timeInsec / 60) + " " + t('MINUTES');
            duration += " " + timeInsec % 60 + " " + t('SECONDS');
        }
        else if (timeInsec && timeInsec > 0) {
            duration = timeInsec + " " + t('SECONDS');
        }
        else {
            duration = "0"
        }
        setTimerString(duration);
    }

    useEffect(() => {
        if (props.expandDrawer) {
            counterBtn.current.style.left = `220.5px`;
        } else {
            counterBtn.current.style.left = `0px`;
        }
    }, [props.expandDrawer]);



    return (
        <Box className={classes.refreshButtonContainer}>
            <Button ref={counterBtn} className={classes.refreshButton} variant="contained" startIcon={<RefreshIcon />} classes={{ iconSizeMedium: classes.myIconSizeMedium }} onClick={refreshData}>
                {t("REFRESHING_IN")} {timerString}
            </Button>
        </Box>
    );
}

function DriverLocator(props) {
    const classes = useStyles();
    const params = useParams();
    const { t } = useTranslation();
    const [statusValue, setStatusValue] = React.useState();
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);
    // const [isApiFailed, setIsApiFailed] = React.useState(false);
    const [isApi, setIsApi] = React.useState(true);
    const [driverList, setdriverList] = useState([]);
    const [filteredDriverList, setFilteredDriverList] = useState([]);
    const [expandDrawer, setExpandDrawer] = useState(true);
    const leftDrawerContainer = useRef<any>();
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [isDriverPopupClosed, setIsDriverPopupClosed] = useState(false);
    const [isResetToDefault, setIsResetToDefault] = useState(true);
    const [isRefresh, setIsRefresh] = useState(true);
    const [startTimer, setStartTimer] = useState(false);

    useEffect(() => {
    }, [selectedDriver])


    const filterCheckBoxes = [
        { title: t("Moving"), checked: true, disabled: false, value: DriverState.MOVING },
        // { title: 'Idling', checked: false, value: DriverState.IDLE },
        { title: t("Parked"), checked: true, disabled: false, value: DriverState.PARKED },
    ];
    const [viewFilterCheckBoxes, setFilterCheckBoxes] = useState(filterCheckBoxes);
    const handleChangeTypesOfEvents = (i) => (e) => {
        let arr = [...viewFilterCheckBoxes];
        arr[i].checked = e.target.checked;
        setFilterCheckBoxes(arr);
    };

    const [searchKey, setSearchKey] = React.useState("");
    const [selectedSortByFilter, setSelectedSortByFilter] = React.useState(null);

    /* const [sortByDriverNameFilter, setSortByDriverNameFilter] = React.useState(
        SortOrder.ASC
    );

    const [sortByDateAndTimeFilter, setSortByDateAndTimeFilter] = React.useState(
        SortOrder.ASC
    ); */

    function getSelectedDriverStates() {
        var selectedDriverStates = [];
        try {
            let checkedBoxes = viewFilterCheckBoxes.filter(
                (item) => item.checked === true
            );
            selectedDriverStates = checkedBoxes.map((item) => item.value);
            selectedDriverStates.push(DriverState.NONE);
            // selectedDriverStates = [0];
        } catch (error) { }
        return selectedDriverStates;
    }

    async function loadData() {
        setStatusValue(null);
        setAlertMessage("");
        setIsAlertOpen(false);
        setIsApi(true);
        params.driverState = [
            DriverState.MOVING,
            DriverState.IDLE,
            DriverState.PARKED,
        ];
        const data = await getDriverList(params);
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201) &&
            data.content
        ) {
            setStartTimer(true);
            setdriverList(data.content);
            setIsApi(false);
            handleFilterDataNew(data.content);
        } else {
            // setIsApiFailed(true);
            setIsApi(false);
            changeApiStatusCodeFunc(data.status);
        }
    }

    const changeApiStatusCodeFunc = (status) => {
        if (
            status.code &&
            status.code !== 0 &&
            status.code !== 200 &&
            status.code !== 201
        ) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };


    const handleFilterDataNew = (userArr) => {
        let result = [];
        setSelectedDriver(null);
        if (userArr.length > 0) {
            let driverSelectedStates = getSelectedDriverStates();
            result = userArr.filter((item) =>
                driverSelectedStates.includes(item.driveState)
            );

            // Check for search
            if (searchKey.length > 0) {
                const searchResult = result.filter((item) => {
                    if (item && item !== undefined) {
                        const driverName = `${item.firstName} ${item.lastName}`;
                        if (driverName.toLowerCase().includes(searchKey.toLowerCase())) {
                            return item;
                        }
                    }
                });
                if (searchResult && searchResult.length > 0) {
                    result = searchResult;
                } else {
                    result = [];
                }
            }
            //Check for sorting
            if (result.length > 0) {
                if (selectedSortByFilter === SortListOrder.ASC) {
                    result.sort((a, b) => ((a.userName).toLowerCase()).localeCompare(((b.userName)).toLowerCase(), 'en', { sensitivity: 'base' }));
                } else if (selectedSortByFilter === SortListOrder.DESC) {
                    result.sort((a, b) => ((b.userName).toLowerCase()).localeCompare(((a.userName)).toLowerCase(), 'en', { sensitivity: 'base' }));
                } else if (selectedSortByFilter === SortListOrder.DATE_ASC) {
                    result.sort((a, b) => new Date(a.driveStateDate).getTime() - new Date(b.driveStateDate).getTime());
                } else if (selectedSortByFilter === SortListOrder.DATE_DESC) {
                    result.sort((a, b) => new Date(b.driveStateDate).getTime() - new Date(a.driveStateDate).getTime());
                }
            }
        }
        setFilteredDriverList(result);
    };

    const handleFilterData = () => {
        let result = [];
        setSelectedDriver(null);
        if (driverList.length > 0) {
            let driverSelectedStates = getSelectedDriverStates();
            result = driverList.filter((item) =>
                driverSelectedStates.includes(item.driveState)
            );

            // Check for search
            if (searchKey.length > 0) {
                const searchResult = result.filter((item) => {
                    if (item && item !== undefined) {
                        const driverName = `${item.firstName} ${item.lastName}`;
                        if (driverName.toLowerCase().includes(searchKey.toLowerCase())) {
                            return item;
                        }
                    }
                });
                if (searchResult && searchResult.length > 0) {
                    result = searchResult;
                } else {
                    result = [];
                }
            }
            //Check for sorting
            if (result.length > 0) {
                if (selectedSortByFilter === SortListOrder.ASC) {
                    result.sort((a, b) => ((a.userName).toLowerCase()).localeCompare(((b.userName)).toLowerCase(), 'en', { sensitivity: 'base' }));
                } else if (selectedSortByFilter === SortListOrder.DESC) {
                    result.sort((a, b) => ((b.userName).toLowerCase()).localeCompare(((a.userName)).toLowerCase(), 'en', { sensitivity: 'base' }));
                } else if (selectedSortByFilter === SortListOrder.DATE_ASC) {
                    result.sort((a, b) => new Date(a.driveStateDate).getTime() - new Date(b.driveStateDate).getTime());
                } else if (selectedSortByFilter === SortListOrder.DATE_DESC) {
                    result.sort((a, b) => new Date(b.driveStateDate).getTime() - new Date(a.driveStateDate).getTime());
                }
            }
        }
        setFilteredDriverList(result);
    };

    const handleSearch = (e) => {
        const key = e.target.value;
        setSearchKey(key);
    };

    useEffect(() => {
        loadData();
    }, [isRefresh]);

    useEffect(() => {
        handleFilterData();
        setExpandDrawer(true);
        if (isResetToDefault) {
            setFilterCheckBoxStates();
        }
        setIsDriverPopupClosed(false);
    }, [searchKey, viewFilterCheckBoxes, selectedSortByFilter]);

    useEffect(() => {
        if (leftDrawerContainer && leftDrawerContainer.current) {
            if (expandDrawer) {
                leftDrawerContainer.current.style.left = 0;
            } else {
                leftDrawerContainer.current.style.left = `-${leftDrawerContainer.current.offsetWidth}px`;
            }
        }
    }, [expandDrawer]);

    function closeCardView() {
        setSelectedDriver(null);
    }

    function setFilterCheckBoxStates() {
        let movingDrivers = driverList.filter(el => el.driveState === DriverState.MOVING);
        let parkedDrivers = driverList.filter(el => el.driveState === DriverState.PARKED);
        let movingDisabled = (movingDrivers && movingDrivers.length > 0) ? false : true;
        let parkedDisabled = (parkedDrivers && parkedDrivers.length > 0) ? false : true;
        let movingChecked = movingDisabled ? false : true;
        let parkedChecked = parkedDisabled ? false : true;
        const filterCheckBoxes = [
            { title: t("Moving"), checked: movingChecked, disabled: movingDisabled, value: DriverState.MOVING },
            // { title: 'Idling', checked: false, value: DriverState.IDLE },
            { title: t("Parked"), checked: parkedChecked, disabled: parkedDisabled, value: DriverState.PARKED },
        ];
        setFilterCheckBoxes(filterCheckBoxes);
    }

    function resetToDefault() {
        setFilterCheckBoxStates();
        setIsResetToDefault(true);
    }

    return (
        <>
            <Counter expandDrawer={expandDrawer} {...props} isRefresh={isRefresh} setIsRefresh={setIsRefresh} startTimer={startTimer}
                setStartTimer={setStartTimer} />
            <CustomGrid container className={classes.mainContainer}>
                <CustomGrid container className={classes.mapsContainer}>
                    <CustomGrid item xs={12}>
                        <PraisoMap
                            {...props}
                            filteredDriverList={filteredDriverList}
                            selectedDriver={selectedDriver}
                            setSelectedDriver={setSelectedDriver}
                            isDriverPopupClosed={isDriverPopupClosed}
                            isResetToDefault={isResetToDefault}
                            setIsResetToDefault={setIsResetToDefault}
                        />
                    </CustomGrid>
                </CustomGrid>
                <div ref={leftDrawerContainer} className={classes.leftDrawerContainer}>
                    <DriverLocatorSidebar
                        {...props}
                        filteredDriverList={filteredDriverList}
                        handleSearch={handleSearch}
                        selectedSortByFilter={selectedSortByFilter}
                        setSelectedSortByFilter={setSelectedSortByFilter}
                        // sortByDriverNameFilter={sortByDriverNameFilter}
                        // setSortByDriverNameFilter={setSortByDriverNameFilter}
                        searchKey={searchKey}
                        setSelectedDriver={setSelectedDriver}
                        selectedDriver={selectedDriver}
                        setIsDriverPopupClosed={setIsDriverPopupClosed}
                        isApi={isApi}
                    ></DriverLocatorSidebar>
                    <CustomBox
                        className={classes.leftDrawerContainerButtonBox}
                        onClick={() => {
                            setExpandDrawer(!expandDrawer);
                        }}
                    >
                        {expandDrawer ? (
                            <ArrowBackIosIcon
                                className={classes.leftDrawerContainerButtonIcon}
                            />
                        ) : (
                            <ArrowForwardIosIcon
                                className={classes.leftDrawerContainerButtonIcon}
                            />
                        )}
                    </CustomBox>
                </div>
                <CustomBox className={classes.rightFilterContainer}>
                    <CustomBox className={classes.checkboxBox} onClick={closeCardView}>
                        <Button className={classes.resetToDefaultButton} variant="contained" startIcon={<ZoomInIcon />} classes={{ iconSizeMedium: classes.myIconSizeMedium }} onClick={resetToDefault}>
                            {t("RESET_TO_DEFAULT")}
                        </Button>
                        {viewFilterCheckBoxes &&
                            viewFilterCheckBoxes.map((checkBox, index) => {
                                return (
                                    <CustomCard key={index} className={classes.checkboxItem}>
                                        <CustomBox>
                                            <CustomFormControlLabel
                                                className={classes.checkboxFormControl}
                                                label={checkBox.title}
                                                control={
                                                    <CustomCheckbox
                                                        color="primary"
                                                        checked={checkBox.checked}
                                                        onChange={handleChangeTypesOfEvents(index)}
                                                        name={checkBox.title}
                                                        disabled={checkBox.disabled}
                                                    />
                                                }
                                            />
                                        </CustomBox>
                                    </CustomCard>
                                );
                            })}
                    </CustomBox>
                </CustomBox>
                <DriverLocatorPopOver
                    {...props}
                    selectedDriver={selectedDriver}
                    setSelectedDriver={setSelectedDriver}
                    setIsDriverPopupClosed={setIsDriverPopupClosed}
                />
            </CustomGrid>
            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                isOpen={isAlertOpen}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />
        </>
    );
}

function PraisoMap(props) {
    const classes = useStyles();
    const [mapUrl] = React.useState(getMapUrl);
    if (mapUrl === undefined || mapUrl === null) {
        if (props.isResetToDefault) {
            props.setIsResetToDefault(false);
        }
        return null;
    }
    function LocationMarker() {
        try {
            const map = useMap();
            if (props.selectedDriver && props.selectedDriver.latitude && props.selectedDriver.longitude) {
                /**Remove previous map layer */
                map.eachLayer(function (layer) {
                    if (layer instanceof L.TileLayer) {

                    } else {
                        map.removeLayer(layer);
                    }
                });

                const marker = props.selectedDriver;
                if (marker) {
                    if (marker.latitude === undefined || marker.latitude === null || marker.latitude === "undefined" || marker.longitude === undefined || marker.longitude === null || marker.longitude === "undefined") {
                        return null;
                    }
                    var icon = redIcon;
                    if (marker.driveState === DriverState.MOVING) {
                        icon = greenIcon;
                    }
                    var newMarker = new L.marker([marker.latitude, marker.longitude], { icon: icon, driverData: marker });
                    let userName = "";
                    if (marker.firstName !== undefined && marker.firstName !== null && marker.firstName.length > 0) {
                        userName = marker.firstName;
                    }
                    if (marker.middleName !== undefined && marker.middleName !== null && marker.middleName.length > 0) {
                        userName += " " + marker.middleName;
                    }
                    if (marker.lastName !== undefined && marker.lastName !== null && marker.lastName.length > 0) {
                        userName += " " + marker.lastName;
                    }
                    newMarker.bindTooltip(userName, { permanent: true, interactive: true, direction: 'right' });
                    newMarker.on('click', setSelectedDriver);
                    newMarker.addTo(map);
                    // map.addLayer(newMarker);
                }


                map.flyTo(
                    {
                        lat: props.selectedDriver.latitude,
                        lng: props.selectedDriver.longitude,
                    },
                    18,
                    { animate: false }
                );
            } else {
                return null;
            }
        } catch (error) {
            console.error(error);
        }
        return null;
    }

    const greenIcon = new L.Icon({
        iconUrl: CircleGreen,
        iconRetinaUrl: CircleGreen,
        iconAnchor: null,
        popupAnchor: null,
        shadowUrl: null,
        shadowSize: null,
        shadowAnchor: null,
        iconSize: new L.Point(30, 30),
        className: "",
    });

    const redIcon = new L.Icon({
        iconUrl: CircleRed,
        iconRetinaUrl: CircleRed,
        iconAnchor: null,
        popupAnchor: null,
        shadowUrl: null,
        shadowSize: null,
        shadowAnchor: null,
        iconSize: new L.Point(30, 30),
        className: "",
    });

    function setSelectedDriver(e) {
        var marker = e.target;
        props.setSelectedDriver(marker.options.driverData);
    }


    /**Add driver location marker */
    function AddMarkers() {
        try {
            const map = useMap();
            // map.on("click", function (e) {
            //     props.setSelectedDriver(null);
            // });

            // if (props.isDriverPopupClosed) {
            //     return null;
            // }

            /**Remove previous map layer */
            map.eachLayer(function (layer) {
                if (!!layer.toGeoJSON) {
                    map.removeLayer(layer);
                }
            });

            if (props && props.filteredDriverList && props.filteredDriverList.length > 0) {
                var markerGroup = [];
                let latlngBounds = null;
                try {
                    var markers = L.markerClusterGroup({
                        iconCreateFunction: function (cluster) {
                            return L.divIcon({ className: classes.mapDivIcon, html: `<div class=${classes.mapClusterIconClass}><span>${cluster.getChildCount()}</span></div>` });
                        },
                        spiderfyShapePositions: function (count, centerPt) {
                            var distanceFromCenter = 35,
                                markerDistance = 45,
                                lineLength = markerDistance * (count - 1),
                                lineStart = centerPt.y - lineLength / 2,
                                res = [],
                                i;

                            res.length = count;

                            for (i = count - 1; i >= 0; i--) {
                                res[i] = new L.Point(centerPt.x + distanceFromCenter, lineStart + markerDistance * i);
                            }

                            return res;
                        }
                    });
                    props.filteredDriverList.map((marker, index) => {
                        var icon = redIcon;
                        if (marker.driveState === DriverState.MOVING) {
                            icon = greenIcon;
                        }
                        if (marker.latitude === undefined || marker.latitude === null || marker.latitude === "undefined" || marker.longitude === undefined || marker.longitude === null || marker.longitude === "undefined") {
                            return null;
                        }
                        var newMarker = new L.marker([marker.latitude, marker.longitude], { icon: icon, driverData: marker });
                        let userName = "";
                        if (marker.firstName !== undefined && marker.firstName !== null && marker.firstName.length > 0) {
                            userName = marker.firstName;
                        }
                        if (marker.middleName !== undefined && marker.middleName !== null && marker.middleName.length > 0) {
                            userName += " " + marker.middleName;
                        }
                        if (marker.lastName !== undefined && marker.lastName !== null && marker.lastName.length > 0) {
                            userName += " " + marker.lastName;
                        }
                        newMarker.bindTooltip(userName, { permanent: true, interactive: true, direction: 'right' });
                        newMarker.on('click', setSelectedDriver);
                        markers.addLayer(newMarker);
                        markerGroup.push([marker.latitude, marker.longitude]);
                    });
                    map.addLayer(markers);
                } catch (error) {
                    console.log(error);
                }

                if (markerGroup.length > 0) {
                    latlngBounds = L.latLngBounds(markerGroup)
                }
                if (props.isResetToDefault) {
                    if (latlngBounds !== null) {
                        map.fitBounds(latlngBounds, { padding: [200, 200], animate: false });
                        props.setIsResetToDefault(false);
                    } else {
                        const result = async () => {
                            let driverswithLatLng = await props.filteredDriverList.filter(el => el.latitude !== undefined && el.latitude !== null);
                            if (driverswithLatLng.length > 0) {
                                return false;
                            }
                            props.setIsResetToDefault(false);
                            return true;
                        }
                        result();
                    }
                }

            } else {
                return null;
            }
        } catch (error) {
            console.log(error);
        }

        return null;
    }

    return (
        <>
            <link
                rel="stylesheet"
                href="https://unpkg.com/leaflet@1.4.0/dist/leaflet.css"
            />
            <MapContainer
                zoomControl={false}
                center={[51.5, 0.12]}
                zoom={6}
                style={{ width: "100%", height: "100%" }}
            >
                <TileLayer url={mapUrl} />
                <AddMarkers />
                <LocationMarker />
            </MapContainer>
        </>
    );
}

// function convertSecToHour(seconds) {
//     try {
//         if (seconds !== undefined && seconds !== null) {
//             /**Convert seconds into hour */
//             return (seconds / (60 * 60)).toFixed(2);
//         }
//     } catch (error) {
//         console.error(error);
//     }
//     return 0;
// }

function secondsToHms(d: any) {
    try {
        var h, m, s: any;
        let duration: any;
        if (d && d > 0 && Number((d / 3600).toFixed(2)) >= 1) {
            h = Math.floor(d / 3600);
            m = Math.floor(d % 3600 / 60);
            duration = `${h} Hrs : ${m} Mins`;
        } else if (d && d > 0 && Number((d / 60).toFixed(2)) > 1 && Number((d / 60).toFixed(2)) < 60) {
            m = Math.floor(d % 3600 / 60);
            s = Math.floor(d % 3600 % 60);
            duration = `${m} Mins : ${s} Secs`;
        } else if (d && d > 0) {
            s = Math.floor(d % 3600 % 60);
            duration = `${s} Secs`;
        } else {
            duration = "-"
        }
        return duration;
    } catch (error) {
        console.log(error);
    }
}


function DriverLocatorPopOver(props) {
    const classes = useStyles();
    const [expandDriverCard, setExpandDriverCard] = useState(true);
    const { t } = useTranslation();
    const history = useHistory();
    const navigateToPage = (e) => {
        e.preventDefault();
        history.push(e.target.getAttribute("href"));
    };

    useEffect(() => {
        if (props.selectedDriver)
            initialDriverPopOver();
    }, [props.selectedDriver])

    function setSelectedDriver() {
        props.setSelectedDriver(null);
        setIsDriverPopupClosed();
    }

    function setIsDriverPopupClosed() {
        props.setIsDriverPopupClosed(true);
        setExpandDriverCard(true);
    }

    function initialDriverPopOver() {
        setExpandDriverCard(true);
        document.getElementById("lastKnownBox").style['display'] = 'flex';
        document.getElementById("lastKnownStateDate").style['display'] = 'flex';
        document.getElementById("driverNameBox").className = classes.driverLocatorPopupNameBox;
        document.getElementById("driverNameUnderlineView").style['display'] = 'block';
        document.getElementById("recentHourBox").style['display'] = 'block';
        document.getElementById("driverCardDivider").style['display'] = 'block';
        document.getElementById("driverCardActionButtonBox").style['display'] = 'block';
    }

    function driverCardClick() {
        setExpandDriverCard(!expandDriverCard);
        if (expandDriverCard) {
            document.getElementById("lastKnownBox").style['display'] = 'none';
            document.getElementById("lastKnownStateDate").style['display'] = 'none';
            document.getElementById("driverNameUnderlineView").style['display'] = 'none';
            document.getElementById("driverNameBox").className = classes.driverLocatorPopupNameBoxShrink;
            document.getElementById("recentHourBox").style['display'] = 'none';
            document.getElementById("driverCardDivider").style['display'] = 'none';
            document.getElementById("driverCardActionButtonBox").style['display'] = 'none';

        } else {
            document.getElementById("lastKnownBox").style['display'] = 'flex';
            document.getElementById("lastKnownStateDate").style['display'] = 'flex';
            document.getElementById("driverNameBox").className = classes.driverLocatorPopupNameBox;
            document.getElementById("driverNameUnderlineView").style['display'] = 'block';
            document.getElementById("recentHourBox").style['display'] = 'block';
            document.getElementById("driverCardDivider").style['display'] = 'block';
            document.getElementById("driverCardActionButtonBox").style['display'] = 'block';
        }
    }

    return (
        <>
            {props.selectedDriver ? (
                <Draggable bounds="parent">
                    <CustomCard className={classes.driverLocatorPopup}>

                        <IconButton onTouchEndCapture={() => { driverCardClick() }} onClick={() => { driverCardClick() }} className={classes.driverLocatorExpandButton}>
                            {expandDriverCard ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
                        </IconButton>

                        <IconButton aria-label="close" className={classes.driverLocatorPopUpCloseButton} onClick={setSelectedDriver} onTouchEndCapture={setSelectedDriver}>
                            <CloseIcon />
                        </IconButton>
                        <CustomBox id="lastKnownBox" className={classes.driverLocatorLastKnownBox}>
                            {props.selectedDriver.driveStateDate !== undefined && props.selectedDriver.driveStateDate !== null ?
                                <>
                                    <CustomBox className={classes.driverLocatorLastKnownBoxIconBox}>
                                        <img
                                            src={props && props.selectedDriver && props.selectedDriver.driveState && props.selectedDriver.driveState === DriverState.MOVING ? CircleGreen : IconParked}
                                            className={clsx(classes.driverLocatorLastKnownBoxIconImage,
                                                props && props.selectedDriver && props.selectedDriver.driveState && props.selectedDriver.driveState !== DriverState.MOVING ? classes.driverLocatorParkedIconImage : null)}
                                        />
                                    </CustomBox>
                                    <CustomBox className={classes.driverLocatorLastKnownBoxText}>
                                        {
                                            props && props.selectedDriver && props.selectedDriver.driveState && props.selectedDriver.driveState === DriverState.MOVING ? t(`LAST_KNOWN_LIVE_TRANSMITTED`) : t(`LAST_KNOWN_LOCATION`)
                                        }
                                    </CustomBox>
                                </> :
                                <>
                                    <CustomBox className={classes.driverLocatorLastKnownBoxText}>
                                        {t(`Data not available`)}
                                    </CustomBox>
                                </>}
                        </CustomBox>
                        <CustomBox id="lastKnownStateDate" className={classes.driverLocatorLastKnownDriveStateDate}>
                            {props.selectedDriver.driveStateDate !== undefined && props.selectedDriver.driveStateDate !== null &&
                                (
                                    <>
                                        <DateTime
                                            inputDate={props.selectedDriver.driveStateDate}
                                            returnFormat="DD MMM YYYY"
                                        /><div className={classes.driverLocatorDateTimeSepertor}>|</div>
                                        <DateTime
                                            inputDate={props.selectedDriver.driveStateDate}
                                            returnFormat="hh:mm A"
                                        />
                                    </>
                                )}
                        </CustomBox>
                        <CustomBox id="driverNameBox"
                            className={classes.driverLocatorPopupNameBox}
                            textAlign="center"
                        >
                            <CustomBox
                                className={classes.driverLocatorPopupName}
                                display="inline-block"
                            >
                                {props.selectedDriver.firstName +
                                    " " +
                                    props.selectedDriver.lastName}
                                <CustomBox id="driverNameUnderlineView" className={classes.driverLocatorPopupNameUnderline} />
                            </CustomBox>
                        </CustomBox>
                        <CustomBox id="recentHourBox" className={classes.driverLocatorPopupRecentHourBox}>
                            <CustomGrid
                                container
                                direction="row"
                                justifyContent="space-evenly"
                                alignItems="center"
                            >
                                <CustomGrid item xs={6}>
                                    <CustomGrid
                                        container
                                        direction="row"
                                        justifyContent="flex-start"
                                        alignItems="center"

                                    >
                                        <CustomGrid item>
                                            <img className={classes.imageIcon} src={RecentEventsIcon} />
                                        </CustomGrid>
                                        <CustomGrid item>
                                            <CustomBox
                                                className={classes.driverLocatorPopupRecentHourBoxTitle}
                                            >
                                                {props.selectedDriver.recentEventCount}
                                            </CustomBox>
                                            <CustomBox
                                                className={
                                                    classes.driverLocatorPopupRecentHourBoxSubTitle
                                                }
                                            >
                                                {t("RECENT_EVENTS")}
                                            </CustomBox>
                                        </CustomGrid>
                                    </CustomGrid>
                                </CustomGrid>
                                <CustomGrid
                                    item
                                    className={classes.driverLocatorPopupHourBox}
                                    xs={6}
                                >
                                    <CustomGrid
                                        container
                                        direction="row"
                                        justifyContent="flex-start"
                                        alignItems="center"
                                    >
                                        <CustomGrid item>
                                            <img className={classes.imageIcon} src={ServiceHoursIcon} />
                                        </CustomGrid>
                                        <CustomGrid item>
                                            <CustomBox
                                                className={classes.driverLocatorPopupRecentHourBoxTitle}
                                            >
                                                {secondsToHms(props?.selectedDriver?.hoursOfService)}
                                            </CustomBox>
                                            <CustomBox
                                                className={
                                                    classes.driverLocatorPopupRecentHourBoxSubTitle
                                                }
                                            >
                                                {t(`Hour of Service`)}
                                            </CustomBox>
                                        </CustomGrid>
                                    </CustomGrid>
                                </CustomGrid>
                            </CustomGrid>
                        </CustomBox>
                        <CustomDivider id="driverCardDivider" className={classes.driverLocatorPopupDivider} />
                        <CustomBox id="driverCardActionButtonBox" className={classes.driverLocatorPopupActionsBox}>
                            <CustomGrid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                spacing={1}
                            >
                                {/* <CustomGrid item>
                                <CustomLink
                                    href={`/userdetails/${props.selectedDriver.userId}`}
                                    onClick={navigateToPage}
                                    className={classes.driverLocatorPopupAction}
                                    underline="none"
                                >
                                    {t(`View Driver`)}
                                </CustomLink>
                            </CustomGrid>
                            <CustomGrid item>
                                <CustomBox className={classes.driverLocatorPopupAction}>
                                    |
                                </CustomBox>
                            </CustomGrid> */}

                                {props.selectedDriver.driveStateDate !== undefined && props.selectedDriver.driveStateDate !== null &&
                                    <CustomGrid item>
                                        <CustomLink
                                            href={`/userdetails/${props.selectedDriver.userId}#tabTrips`}
                                            onClick={navigateToPage}
                                            onTouchEndCapture={navigateToPage}
                                            className={classes.driverLocatorPopupAction}
                                            underline="none"
                                        >
                                            {t(`View Journey`)}
                                        </CustomLink>
                                    </CustomGrid>}
                            </CustomGrid>
                        </CustomBox>
                    </CustomCard>
                </Draggable>
            ) : null}
        </>
    );
}

export default DriverLocator;

